// Define nativebase theme  config
const config = {
  useSystemColorMode: false,
  // initialColorMode: 'dark',
}

export default config
